// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"99207c21","147":"48198676","295":"0ba59d4f","362":"6eb1b9a5","574":"d0221ff1","807":"4bc5bbac","818":"737f2cf7","899":"10cb1c1e","900":"815301c4","996":"644114e3"}[chunkId] + ".chunk.js";
};